<template>
  <el-dialog :title="form.id?'编辑':'新建'" :visible.sync="formVisible" width="900px" :close-on-click-modal="false" @close="handleClose">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="主播" prop="userId" class="width100">
        <div style="display: flex; align-items: center;">
          <el-select v-model="form.position" placeholder="请选择查询方式" style="width: 180px;">
            <el-option label="手机号" :value="'phone'"></el-option>
            <el-option label="昵称" :value="'name'"></el-option>
          </el-select>
          <el-select v-model="form.userId" filterable remote :placeholder="form.position==='phone' ? '请通过手机号搜索主播' : '请通过昵称搜索主播'" :remote-method="searchUsers" :loading="loading1">
            <el-option v-for="item in usersOptions" :key="item.id" :label="item.liveName + '-' + item.userPhone + '-' + item.positionName + '-' + item.userId" :value="item.userId">
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="直播主图(9:16例如:1242*2208)" prop="liveImg" class="width100">
        <imageUpload v-model="form.liveImg" width="32" height="32" />
      </el-form-item>
      <el-form-item label="直播主题" prop="title">
        <el-input v-model="form.title" placeholder="请输入直播主题" />
      </el-form-item>
      <el-form-item label="直播类型" prop="liveType">
        <el-select v-model="form.liveType" placeholder="请选择直播类型">
          <el-option label="带货竖屏直播" :value="1"></el-option>
          <el-option label="培训横屏直播" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="观看权限" :prop="form.liveAuth ? 'liveAuth.authType' : ''" class="width100">
        <el-radio-group v-model="form.liveAuth.authType" v-if="form.liveAuth">
          <el-radio :label="1">所有人观看</el-radio>
          <el-radio :label="2">密码观看</el-radio>
          <el-radio :label="3">部分人观看</el-radio>
          <el-radio :label="4">部分人身份观看</el-radio>
          <el-radio :label="5">部分标签观看</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="密码" :prop="form.liveAuth && form.liveAuth.authType === 2 ? 'liveAuth.authTwo' : ''" class="width100" v-if="form.liveAuth && form.liveAuth.authType === 2">
        <el-input v-model="form.liveAuth.authTwo" placeholder="请输入密码" />
      </el-form-item>
      <el-form-item label="观看人员" :prop="form.liveAuth && form.liveAuth.authType === 3 ? 'liveAuth.authThree' : ''" v-if="form.liveAuth && form.liveAuth.authType === 3">
        <el-select v-model="form.liveAuth.authThree" multiple filterable remote placeholder="请选择观看人员" :remote-method="searchViewers" :loading="loading">
          <el-option v-for="item in viewersOptions" :key="item.id" :label="item.realName + '('+ item.userPho+')' + item.position" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="观看身份" :prop="form.liveAuth && form.liveAuth.authType === 4 ? 'liveAuth.authFour' : ''" class="width100" v-if="form.liveAuth && form.liveAuth.authType === 4">
        <el-cascader v-model="form.liveAuth.authFour" :options="roleOptions" :props="cascaderProps" placeholder="请选择观看身份" multiple collapse-tags style="width: 100%;" />
      </el-form-item>
      <el-form-item label="观看标签" :prop="form.liveAuth && form.liveAuth.authType === 5 ? 'liveAuth.authFive' : ''" class="width100" v-if="form.liveAuth && form.liveAuth.authType === 5">
        <el-cascader v-model="form.liveAuth.authFive" :options="labelList" :props="labelProps" :show-all-levels="false" placeholder="请选择标签">
        </el-cascader>
      </el-form-item>

      <el-form-item label="管理员" prop="liveAdmins" class="width100">
        <el-select v-model="form.liveAdmins" filterable remote placeholder="请选择管理员" :remote-method="searchAdmins" :loading="loading">
          <el-option v-for="item in adminsOptions" :key="item.id" :label="item.realName + '('+ item.userPho+')' + item.position" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开播时间" prop="startTime">
        <el-date-picker v-model="form.startTime" size="small" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"></el-date-picker>
      </el-form-item>
      <el-form-item label="虚拟观看人数" prop="lookUserVirtualcount">
        <el-input v-model="form.lookUserVirtualcount" placeholder="请输入虚拟观看人数" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'
import ImageUpload from "@/components/ImageUpload";
function initFormBean() {
  const formBean = {
    liveAdmins: null,
    liveAuth: {
      authFive: '',
      authFiveStr: '',
      authFour: '',
      authThree: '',
      authThreeStr: '',
      authTwo: '',
      authType: 1,
    },
    liveImg: null,
    liveType: null,
    lookUserVirtualcount: null,
    startTime: null,
    title: null,
    userId: null,
    position: 'phone',
  }
  return formBean
}
// 用户类型常量
const USER_TECHNOLOGY_TYPE = 1 // 技术线
const USER_BUSINESS_TYPE = 2 // 业务线

export default {
  components: { ImageUpload },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        position: [{ required: true, message: '请选择查询方式', trigger: 'change' }],
        userId: [{ required: true, message: '请通过直播昵称搜索主播', trigger: 'change' }],
        liveImg: [{ required: true, message: '请上传直播主图', trigger: 'change' }],
        title: [{ required: true, message: '请输入直播主题', trigger: 'blur' }],
        liveType: [{ required: true, message: '请选择直播类型', trigger: 'change' }],
        'liveAuth.authType': [{ required: true, message: '请选择观看权限', trigger: 'change' }],
        'liveAuth.authTwo': [{
          required: true,
          message: '请输入密码',
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (this.form.liveAuth && this.form.liveAuth.authType === 2 && !value) {
              callback(new Error('请输入密码'));
            } else {
              callback();
            }
          }
        }],
        liveAdmins: [{
          required: true,
          message: '请选择管理员',
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请选择管理员'));
            } else {
              callback();
            }
          }
        }],
        startTime: [{ required: true, message: '请选择开播时间', trigger: 'change' }],
        lookUserVirtualcount: [{ required: true, message: '请输入虚拟观看人数', trigger: 'blur' }],

        // 条件验证规则
        'liveAuth.authThree': [{
          required: true,
          message: '请选择观看人员',
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (this.form.liveAuth && this.form.liveAuth.authType === 3 && (!value || value.length === 0)) {
              callback(new Error('请选择观看人员'));
            } else {
              callback();
            }
          }
        }],
        'liveAuth.authFour': [{
          required: true,
          message: '请选择观看身份',
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (this.form.liveAuth && this.form.liveAuth.authType === 4 && (!value || value.length === 0)) {
              callback(new Error('请选择观看身份'));
            } else {
              callback();
            }
          }
        }],
        'liveAuth.authFive': [{
          required: true,
          message: '请选择观看标签',
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (this.form.liveAuth && this.form.liveAuth.authType === 5 && (!value || (Array.isArray(value) && value.length === 0))) {
              callback(new Error('请选择观看标签'));
            } else {
              callback();
            }
          }
        }]
      },
      isRepSub: false,
      usersOptions: [],
      adminsOptions: [],
      viewersOptions: [], // 观看人员选项
      viewersMap: {}, // 存储所有搜索过的用户信息 {id: {id, realName, userPho, position}}
      loading: false,
      loading1: false,
      roleOptions: [], // 从接口获取身份数据
      cascaderProps: {
        value: 'value',
        label: 'label',
        children: 'children',
        multiple: true,
      },
      labelList: [],
      labelMap: {}, // 存储所有标签组的完整信息
      labelProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        multiple: true
      }
    }
  },
  created() {
    this.getLabelList()
    this.getIdentityList()
  },
  methods: {
    getLabelList() {
      liveManageApi.getTag().then((response) => {
        if (response.code === '0' && response.data && Array.isArray(response.data)) {
          // 按 groupId 分组
          const groupedByGroupId = {}
          response.data.forEach(tag => {
            const groupId = tag.groupId || 0
            if (!groupedByGroupId[groupId]) {
              groupedByGroupId[groupId] = []
            }
            groupedByGroupId[groupId].push({
              id: tag.id,
              name: tag.name
            })
          })
          
          // 转换为 cascader 需要的格式
          this.labelList = Object.keys(groupedByGroupId).map(groupId => {
            const tags = groupedByGroupId[groupId]
            // 保存到 labelMap
            this.labelMap[groupId] = {
              id: Number(groupId),
              name: `标签组${groupId}`,
              tags: tags
            }
          
          return {
              id: Number(groupId),
              name: `标签组${groupId}`,
              children: tags
          }
        })
        } else {
          this.labelList = []
        }
      }).catch(err => {
        console.error('获取标签列表失败:', err)
        this.labelList = []
      })
    },
    // 获取身份列表
    getIdentityList() {
      liveManageApi.getAllIdentity().then(({ data }) => {
        if (data && Array.isArray(data)) {
          // 按 type 分组
          const groupedByType = {}
          data.forEach(item => {
            if (item.type !== undefined && item.type !== null) {
              if (!groupedByType[item.type]) {
                groupedByType[item.type] = []
              }
              groupedByType[item.type].push({
                value: item.id,
                label: item.name || ''
              })
            }
          })
          
          // 转换为 cascader 需要的格式
          this.roleOptions = Object.keys(groupedByType).map(type => {
            // type: 1=技术线, 2=业务线, 其他可能是内部人员等
            let label = ''
            if (type === '1' || type === 1) {
              label = '技术线'
            } else if (type === '2' || type === 2) {
              label = '业务线'
            } else {
              // 其他类型，尝试从第一个子项获取类型名称，或使用默认名称
              label = '其他'
            }
            
            return {
              value: Number(type),
              label: label,
              children: groupedByType[type]
            }
          })
        } else {
          // 如果接口返回数据格式不对，使用默认值
          this.roleOptions = []
        }
      }).catch(err => {
        console.error('获取身份列表失败:', err)
        this.roleOptions = []
      })
    },
    searchAdmins(query) {
      if (query !== '') {
        this.loading1 = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading1 = false;
          liveManageApi.searchUser({ keyword: query }).then(({ data }) => {
            this.adminsOptions = data;
          })
        }, 500);
      } else {
        this.adminsOptions = [];
      }
    },
    searchUsers(query) {
      if (query !== '') {
        this.loading1 = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading1 = false;
          const params = { state: 1, pageSize: 100 }
          if (this.form.position === 'phone') {
            params.anchorPhone = query
          } else {
            params.liveName = query
          }
          liveManageApi.fetchListAnchor(params).then(({ data }) => {
            this.usersOptions = data.list;
          })
        }, 500);
      } else {
        this.usersOptions = [];
      }
    },
    searchViewers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          liveManageApi.searchUser({ keyword: query }).then(({ data }) => {
            this.viewersOptions = data;
            // 保存用户信息到 viewersMap
            data.forEach(user => {
              this.viewersMap[user.id] = {
                id: user.id,
                realName: user.realName,
                userPho: user.userPho,
                position: user.position
              }
            })
          })
        }, 500);
      } else {
        this.viewersOptions = [];
      }
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
      this.selectedUserTypes = []
      this.selectedTechRoles = []
      this.selectedBusinessRoles = []
      this.adminsOptions = []
      this.usersOptions = []
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        // 安全地调用 clearValidate
        if (this.$refs['dataForm'] && this.$refs['dataForm'].clearValidate) {
          this.$refs['dataForm'].clearValidate()
        }
      })
    },
    
    /**
     * 处理弹窗关闭事件
     */
    handleClose() {
      this.formVisible = false
      this.resetForm()
    },
    handleUpdate(row) {
      this.resetForm()
      // 通过API获取直播详情
      liveManageApi.getLiveById(row.livePO.id).then(response => {
        if (response.code === '0' && response.data) {
          // 重置表单，使用默认值
          this.form = initFormBean()
          
          // 从 livePO 对象中获取直播信息
          if (response.data.livePO) {
            // 只设置必要的字段，不要合并整个 livePO 对象
            this.form.id = response.data.livePO.id
            this.form.title = response.data.livePO.title || ''
            this.form.liveImg = response.data.livePO.liveImg || ''
            this.form.liveType = response.data.livePO.liveType || 1
            this.form.startTime = response.data.livePO.startTime || ''
            this.form.lookUserVirtualcount = response.data.livePO.lookUserVirtualcount || 0
          }
          
          // 从 liveAnchorPO 对象中获取主播信息
          if (response.data.liveAnchorPO) {
            // 只设置主播相关的必要字段，不要覆盖筛选条件
            this.form.userId = response.data.liveAnchorPO.userId
            
            // 设置主播选项，用于显示当前选中的主播
            this.usersOptions = [{
              id: response.data.liveAnchorPO.id,
              userId: response.data.liveAnchorPO.userId,
              liveName: response.data.liveAnchorPO.liveName || '',
              userPhone: response.data.liveAnchorPO.phone || '',
              positionName: response.data.liveAnchorPO.position || ''
            }]
          }
          
          // 从 liveAuthPO 对象中获取 liveAuth 数据
          if (response.data.liveAuthPO) {
            this.form.liveAuth = { ...response.data.liveAuthPO }
            // 保留观看权限记录本身的主键；直播主键单独保存在 form.id。
            
            // 处理 authFour 数据格式转换（需要从字符串转换为数组格式供 cascader 使用）
            if (this.form.liveAuth.authFour && this.form.liveAuth.authType === 4) {
              try {
                // 如果是字符串，先解析
                let authFourData = this.form.liveAuth.authFour;
                if (typeof authFourData === 'string') {
                  authFourData = JSON.parse(authFourData);
                }
                // 反向转换为 cascader 需要的格式
                this.form.liveAuth.authFour = this.reverseAuthFormat(authFourData);
              } catch (e) {
                console.error('解析 authFour 失败:', e);
                this.form.liveAuth.authFour = [];
              }
            }
            
            // 处理 authFive 数据格式转换（从 authFiveStr 中取值并转换为 cascader 需要的格式）
            if (this.form.liveAuth.authType === 5) {
              console.log('===== 编辑时回显观看标签 =====')
              console.log('authFiveStr:', this.form.liveAuth.authFiveStr)
              console.log('authFive:', this.form.liveAuth.authFive)
              
              try {
                // 优先从 authFiveStr 中解析标签信息
                if (this.form.liveAuth.authFiveStr) {
                  let authFiveStrData = this.form.liveAuth.authFiveStr;
                  if (typeof authFiveStrData === 'string') {
                    authFiveStrData = JSON.parse(authFiveStrData);
                  }
                  
                  console.log('解析后的authFiveStrData:', authFiveStrData)
                  
                  if (Array.isArray(authFiveStrData) && authFiveStrData.length > 0) {
                    // authFiveStr格式: [{id: 2, name: "标签2组", tags: [{id: 3, name: "测试1"}, {id: 4, name: "测试2"}]}]
                    // 转换为 cascader 需要的格式: [[groupId, tagId], [groupId, tagId]]
                    const cascaderValue = [];
                    
                    authFiveStrData.forEach(group => {
                      if (group.tags && Array.isArray(group.tags) && group.tags.length > 0) {
                        group.tags.forEach(tag => {
                          cascaderValue.push([group.id, tag.id]);
                        });
                      }
                    });
                    
                    console.log('转换后的cascader值:', cascaderValue);
                    this.form.liveAuth.authFive = cascaderValue;
                  } else {
                    console.log('authFiveStrData为空或不是数组，尝试从authFive解析');
                    this.form.liveAuth.authFive = [];
                  }
                } else {
                  // 如果没有 authFiveStr，尝试从 authFive 中解析（降级方案）
                  console.log('authFiveStr不存在，尝试从authFive解析');
                  if (this.form.liveAuth.authFive) {
                    let authFiveData = this.form.liveAuth.authFive;
                    if (typeof authFiveData === 'string') {
                      authFiveData = JSON.parse(authFiveData);
                    }
                    // 从 processTagData 的格式反向转换
                    // processTagData 返回: [{tagtype: 1, typevalue: [tagIds]}]
                    if (Array.isArray(authFiveData) && authFiveData.length > 0) {
                      const tagData = authFiveData[0];
                      if (tagData.tagtype && Array.isArray(tagData.typevalue)) {
                        // 无法知道标签组ID，暂时设为空数组
                        console.warn('无法从authFive恢复标签组信息，需要authFiveStr');
                        this.form.liveAuth.authFive = [];
                      } else {
                        this.form.liveAuth.authFive = [];
                      }
                    } else {
                      this.form.liveAuth.authFive = [];
                    }
                  } else {
                    this.form.liveAuth.authFive = [];
                  }
                }
              } catch (e) {
                console.error('解析 authFive/authFiveStr 失败:', e);
                this.form.liveAuth.authFive = [];
              }
            }
          } else {
            // 如果 liveAuthPO 不存在，使用默认值
            this.form.liveAuth = {
              authFive: '',
              authFour: '',
              authThree: '',
              authTwo: '',
              authType: 1,
              id: null,
            }
          }
          
          // 处理管理员数据 (liveAdminPOList)
          if (response.data.liveAdminPOList && Array.isArray(response.data.liveAdminPOList) && response.data.liveAdminPOList.length > 0) {
            // 取第一个管理员（因为现在是单选）
            const admin = response.data.liveAdminPOList[0]
            // 设置管理员ID
            this.form.liveAdmins = admin.userId
            // 将管理员信息添加到选项中，以便下拉框能显示
            this.adminsOptions = [{
              id: admin.userId,
              userId: admin.userId,
              realName: admin.adminName || '',
              userPho: admin.adminPhone || '',
              position: admin.adminPosition || ''
            }]
          } else {
            // 如果没有管理员数据，清空
            this.form.liveAdmins = null
            this.adminsOptions = []
          }
          
          this.formVisible = true
          this.$nextTick(() => {
            // 安全地调用 clearValidate
            if (this.$refs['dataForm'] && this.$refs['dataForm'].clearValidate) {
              this.$refs['dataForm'].clearValidate()
            }
          })
        } else {
          this.$message.error('获取直播详情失败')
        }
      }).catch(error => {
        console.error('获取直播详情失败:', error)
        this.$message.error('获取直播详情失败')
      })
    },

    /**
     * 处理身份观看权限格式转换
     * @param {Array} authArray - 原始权限数组，如 [[1,1], [1,2], [2,1], [2,2]]
     * @returns {Array} 转换后的格式 [{ "type":2,"name":"总监","id":1 }]
     */
    processAuthFormat(authArray) {
      if (!Array.isArray(authArray)) return [];

      const result = [];

      // 创建一个映射表，用于查找角色名称
      const roleMap = {};
      this.roleOptions.forEach(line => {
        line.children.forEach(role => {
          roleMap[`${line.value}-${role.value}`] = role.label;
        });
      });

      authArray.forEach(item => {
        if (Array.isArray(item) && item.length >= 2) {
          const [userType, roleId] = item;
          
          // 查找对应的角色名称
          const roleName = roleMap[`${userType}-${roleId}`] || `身份${roleId}`;
          
          result.push({
            type: userType,
            name: roleName,
            id: roleId
          });
        }
      });

      return result;
    },

    /**
     * 反向转换：从新格式转回原始格式
     * @param {Array|String} authFormat - 新格式权限数组或JSON字符串
     * @returns {Array} 原始格式数组 [[1,1], [2,1]]
     */
    reverseAuthFormat(authFormat) {
      // 如果是字符串，先解析
      if (typeof authFormat === 'string') {
        try {
          authFormat = JSON.parse(authFormat);
        } catch (e) {
          console.error('解析权限数据失败:', e);
          return [];
        }
      }
      
      if (!Array.isArray(authFormat)) return [];

      const result = [];
      authFormat.forEach(item => {
        // 支持两种格式：新格式 {type, name, id} 和旧格式 {usertype, typevalue}
        if (item.type !== undefined && item.id !== undefined) {
          // 新格式
          result.push([item.type, item.id]);
        } else if (item.usertype && Array.isArray(item.typevalue)) {
          // 旧格式
          item.typevalue.forEach(typeValue => {
            result.push([item.usertype, typeValue]);
          });
        }
      });

      return result;
    },
    processAuthData(formData) {
      const { liveAuth } = formData
      
      // 安全检查：确保 liveAuth 存在
      if (!liveAuth) {
        console.warn('liveAuth 数据不存在，跳过权限数据处理')
        return
      }
      
      // 定义权限字段映射
      const authFields = { authTwo: '', authThree: '', authFour: '', authFive: '' }
      // 根据权限类型处理数据
      switch (liveAuth.authType) {
        case 1: // 所有人观看
          // 清空所有权限字段
          Object.assign(liveAuth, authFields)
          break
        case 2: // 密码观看
          // 保留密码，清空其他字段
          Object.assign(liveAuth, { authThree: '', authFour: '', authFive: '' })
          // 密码字段已在表单中设置，无需额外处理
          break

        case 3: // 部分人观看
          // 处理用户ID列表
          if (liveAuth.authThree && liveAuth.authThree.length > 0) {
            liveAuth.authThree = liveAuth.authThree.join(',')
            
            // 生成 authThreeStr：包含完整的用户信息
            const userList = liveAuth.authThree.split(',').map(userId => {
              const user = this.viewersMap[userId]
              if (user) {
                return {
                  id: user.id,
                  realName: user.realName,
                  userPho: user.userPho,
                  position: user.position
                }
              }
              return null
            }).filter(Boolean) // 过滤掉 null 值
            
            liveAuth.authThreeStr = JSON.stringify(userList)
          } else {
            liveAuth.authThree = ''
            liveAuth.authThreeStr = ''
          }
          // 清空其他权限字段
          Object.assign(liveAuth, { authTwo: '', authFour: '', authFive: '' })
          break

        case 4: // 部分身份观看
          // authFour 通过 processAuthFormat 转换为新格式 [{ "type":2,"name":"总监","id":1 }]
          // 然后 JSON.stringify 转为字符串
          if (liveAuth.authFour && Array.isArray(liveAuth.authFour)) {
            const formattedData = this.processAuthFormat(liveAuth.authFour)
            liveAuth.authFour = JSON.stringify(formattedData)
          } else {
            liveAuth.authFour = ''
          }
          Object.assign(liveAuth, { authTwo: '', authThree: '', authFive: '' })
          break

        case 5: // 部分标签观看
          console.log('===== 处理部分标签观看权限 =====')
          console.log('1. 用户选择的标签数据 liveAuth.authFive:', liveAuth.authFive)
          console.log('2. authFive类型:', typeof liveAuth.authFive)
          console.log('3. authFive是否为数组:', Array.isArray(liveAuth.authFive))
          
          // 处理标签数据
          if (liveAuth.authFive && Array.isArray(liveAuth.authFive)) {
            // 先保存原始数组用于生成 authFiveStr
            const tagArray = liveAuth.authFive
            console.log('4. 标签数组 tagArray:', tagArray)
            
            // 生成 authFiveStr：包含标签组和标签的完整信息
            const tagGroupMap = {} // 按标签组分组标签
            
            tagArray.forEach((tagItem, index) => {
              console.log(`5. 处理标签项[${index}]:`, tagItem)
              
              if (Array.isArray(tagItem) && tagItem.length === 2) {
                const [groupId, tagId] = tagItem
                console.log(`   标签组ID: ${groupId}, 标签ID: ${tagId}`)
                
                if (!tagGroupMap[groupId]) {
                  // 确保类型匹配
                  const groupInfo = this.labelMap[groupId] || this.labelMap[String(groupId)]
                  console.log(`   查找标签组信息，groupId=${groupId}:`, groupInfo)
                  
                  if (groupInfo) {
                    tagGroupMap[groupId] = {
                      id: groupInfo.id,
                      name: groupInfo.name,
                      tags: []
                    }
                    console.log(`   创建标签组映射:`, tagGroupMap[groupId])
                  } else {
                    console.warn('找不到标签组信息:', { groupId, availableGroups: Object.keys(this.labelMap), labelMap: this.labelMap })
                  }
                }
                
                // 查找标签信息
                if (tagGroupMap[groupId]) {
                  // 确保类型匹配查找标签组
                  const groupInfo = this.labelMap[groupId] || this.labelMap[String(groupId)]
                  console.log(`   再次查找标签组信息用于标签查找:`, groupInfo)
                  
                  if (groupInfo) {
                    console.log(`   labelMap中该组的tags:`, groupInfo.tags)
                    
                    // 确保类型匹配：tagId 可能是字符串或数字
                    const tagInfo = groupInfo.tags.find(tag => String(tag.id) === String(tagId))
                    console.log(`   查找标签信息，tagId=${tagId}:`, tagInfo)
                    
                    if (tagInfo) {
                      const tagData = {
                        id: tagInfo.id,
                        name: tagInfo.name,
                        image: tagInfo.image || null
                      }
                      console.log(`   添加到标签组的数据:`, tagData)
                      
                      tagGroupMap[groupId].tags.push(tagData)
                    } else {
                      console.warn('找不到标签信息:', { groupId, tagId, availableTags: groupInfo.tags })
                    }
                  }
                }
              } else {
                console.warn(`标签项[${index}]格式不正确:`, tagItem)
              }
            })
            
            console.log('6. 最终的tagGroupMap:', tagGroupMap)
            console.log('7. tagGroupMap的所有值:', Object.values(tagGroupMap))
            
            // 转换为数组格式
            liveAuth.authFiveStr = JSON.stringify(Object.values(tagGroupMap))
            console.log('8. 最终生成的authFiveStr:', liveAuth.authFiveStr)
            
            // 将 authFive 转换为标签ID字符串，用英文逗号隔开
            const tagIds = tagArray.map(subArray => subArray[subArray.length - 1])
            liveAuth.authFive = tagIds.join(',')
            console.log('9. 最终生成的authFive:', liveAuth.authFive)
          } else {
            console.log('authFive不是数组或为空，清空字段')
            liveAuth.authFive = ''
            liveAuth.authFiveStr = ''
          }
          // 清空其他权限字段
          Object.assign(liveAuth, { authTwo: '', authThree: '', authFour: '' })
          break
      }
    },

    /**
     * 处理标签数据为JSON格式
     */
    processTagData(tagArray) {
      const tagtype = 1
      return JSON.stringify([{
        tagtype: tagtype,
        typevalue: tagArray.length ? tagArray.map(subArray => subArray[subArray.length - 1]) : []
      }])
    },
    // processTagData(tagArray) {
    //   const groupedTags = {}

    //   // 按标签类型分组
    //   tagArray.forEach(tag => {
    //     if (tag.length === 2) {
    //       const [tagType, tagValue] = tag

    //       if (!groupedTags[tagType]) {
    //         groupedTags[tagType] = []
    //       }
    //       groupedTags[tagType].push(tagValue)
    //     }
    //   })

    //   // 生成authFive格式
    //   return JSON.stringify(
    //     Object.keys(groupedTags).map(tagType => ({
    //       tagtype: parseInt(tagType),
    //       typevalue: groupedTags[tagType]
    //     }))
    //   )
    // },

    /**
     * 处理管理员数据
     */
    processAdminData(formData) {
      // 单选模式下，将单个值转换为数组格式（如果后端需要数组格式）
      if (formData.liveAdmins !== null && formData.liveAdmins !== undefined) {
        // 如果是单个值，转换为数组
        if (!Array.isArray(formData.liveAdmins)) {
        formData.liveAdmins = [formData.liveAdmins]
      }
      } else {
      // 如果管理员为空，设置为空数组
        formData.liveAdmins = []
      }
    },
    prepareSubmitData() {
      const formData = JSON.parse(JSON.stringify(this.form))

      // 移除前端特有的字段
      delete formData.position
      // 处理观看权限相关数据
      this.processAuthData(formData)
      // 处理管理员数据格式
      this.processAdminData(formData)
      // 处理虚拟观看人数
      if (formData.lookUserVirtualcount) {
        formData.lookUserVirtualcount = parseInt(formData.lookUserVirtualcount)
      }
      // 处理直播类型
      if (formData.liveType) {
        formData.liveType = parseInt(formData.liveType)
      }
      // 处理主播ID
      if (formData.userId) {
        formData.userId = parseInt(formData.userId)
      }
      return formData
    },
    /**
     * 执行新建/编辑操作
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let parasm = this.prepareSubmitData()
          delete parasm.position
          if (this.isRepSub) return
          this.isRepSub = true
          
          // 统一使用createLive接口，id为null时新增，有值时修改
          liveManageApi.createLive(parasm).then((data) => {
            this.postCallback(data)
          }).catch(res => {
            this.isRepSub = false
          });
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-date-editor {
  width: 100%;
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>
